module.exports = __webpack_public_path__ + "img/logo-mini.54c968c9.jpeg";